<div class="wrapper-company-plan">
  <div class="wrapper-left-company-plan">
    <img src="../../../../../../assets/icons/fill/icon-fill-company.svg" alt="">
    <div class="btn-yellow-company">
      <span>{{'NEW_TEXT.company' | translate}}</span>
    </div>
    <p>39.99$ <span>/ {{'NEW_TEXT.month' | translate}}</span></p>
  </div>
  <div class="wrapper-right-company-plan">
    <div class="item-company-plan">
      <div class="wrapper-circle-company-plan">
        <img src="../../../../../../assets/icons/outline/icon-check.svg" alt="">
      </div>
      <span>{{'NEW_TEXT.no_ads' | translate}}</span>
    </div>
    <div class="item-company-plan">
      <div class="wrapper-circle-company-plan">
        <img src="../../../../../../assets/icons/outline/icon-check.svg" alt="">
      </div>
      <span>{{'NEW_TEXT.sponsored_lists' | translate}}</span>
    </div>
    <div class="item-company-plan">
      <div class="wrapper-circle-company-plan">
        <img src="../../../../../../assets/icons/outline/icon-check.svg" alt="">
      </div>
      <span>{{'NEW_TEXT.recommended_lists' | translate}}</span>
    </div>
    <div class="item-company-plan">
      <div class="wrapper-circle-company-plan">
        <img src="../../../../../../assets/icons/outline/icon-check.svg" alt="">
      </div>
      <span>{{'NEW_TEXT.up_to_50_private_lists' | translate}}</span>
    </div>
  </div>
</div>
<button type="submit" (click)="clickToSubscribe.emit()" class="custom-btn custom-btn--primary">
  <span>{{'NEW_TEXT.subscribe' | translate}}</span>
</button>

